import { Action } from "redux";

export const LIST_COUNTRIES = "LIST_COUNTRIES";

export interface ListCountriesAction extends Action {
  type: typeof LIST_COUNTRIES;
}

export const listCountries = (): ListCountriesAction => ({
  type: LIST_COUNTRIES,
});
